/**
 * RealEstateSearchLayer用の備考同期システム
 * PropertySelectionGridとRealEstateSearchポップアップ間で備考データを同期するためのユーティリティ
 */

import { createIndexedPropertyGridPopupSyncSystem } from "./createSyncSystem";

export const REAL_ESTATE_SEARCH_REMARKS_UPDATE_EVENT =
  "updateRealEstateSearchRemarks";

const { dispatch, addListener } =
  createIndexedPropertyGridPopupSyncSystem<string>(
    REAL_ESTATE_SEARCH_REMARKS_UPDATE_EVENT
  );

/**
 * RealEstateSearchの備考更新イベントを発火する
 * @param index 不動産検索結果のインデックス
 * @param remarks 更新する備考
 */
export const dispatchRealEstateSearchRemarksUpdate = (
  index: number,
  remarks: string
): void => {
  dispatch(index, remarks);
};

/**
 * RealEstateSearchの備考更新イベントリスナーを追加する
 * @param targetIndex リスナーを登録する対象のインデックス
 * @param callback 備考が更新された際に呼び出されるコールバック関数
 * @returns クリーンアップ関数
 */
export const addRealEstateSearchRemarksUpdateListener = (
  targetIndex: number,
  callback: (remarks: string) => void
): (() => void) => {
  return addListener(targetIndex, callback);
};
